export const OPERATION_OPTIONS = [
  { value: "insert", label: "Inserir" },
  { value: "insertOrUpdate", label: "Inserir/Atualizar" },
  { value: "update", label: "Atualizar" },
  { value: "delete", label: "Excluir" }
];

export const ENTITY_TYPES_OPTIONS = [
  { value: 1, label: "Agente", slug: "agent" },
  { value: 2, label: "Local Atendimento", slug: "location" },
  { value: 3, label: "Item", slug: "item" },
  { value: 4, label: "Tarefa", slug: "task" },
  { value: 6, label: "Cadastro Customizável", slug: "customEntityEntry" },
  { value: 15, label: "Itens do Local", slug: "serviceLocalItem" }
];

export const EXECUTION_MODULES_OPTIONS = [
  { value: "mobile", label: "Mobile" },
  { value: "watcher", label: "Watcher" },
  { value: "both", label: "Mobile/Watcher" }
];

export const EXECUTION_MOMENTS_OPTIONS = [
  {
    value: 1,
    label: "Ao finalizar atividade da tarefa",
    slug: "finalize-activity-task"
  },
  { value: 2, label: "Ao finalizar item", slug: "finalize-item" }
];
